import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/groups`;

export type * from './viewModel';

export const ROUTE: RouteDefinition = `${baseRoute}/groups`;

export const URL = (): RouteDefinition => `${baseRoute}/groups`;
